<template>
    <div>
        <LabelList :type="type"></LabelList>
    </div>
</template>

<script>
    import LabelList from './components/labelList';

    export default {
        name: "Mechanism",
        components: {
            LabelList
        },
        data() {
            return {
                type:"ORGANIZATION_LABEL"
            };
        }
    }
</script>

<style lang="less" scoped>

</style>